import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import GridWrapper from "../../../components/controls/GridWrapper";
import { TextInput } from "../../../components/controls/inputs/BaseInput";
import BaseCreator from "../../../components/creators/baseCreator";
import { IEmployeeDTO } from "../../../libs/coreapi-dto/dirs/employee";
import modalStyles from '../../../components/modalWindows/styles/BaseModalWindow.module.scss'
import { useForm } from "../../../system/hooks/useForm";
import GridSelectorInput from "../../../components/controls/GridSelectorInput";
import { IEntitySimpleDTO } from "../../../libs/coreapi-dto/@types/common";
import { IOption, Select } from "../../../components/selects/select";
import UserLocalSelectorModal from "../../Service/UserLocal/components/selectorModal/UserLocalSelectorModal";
import { useAppContext } from "../../../system/providers/appContextProvider";
import { UserLocalDataProvider } from "../../../Services/DataProviders/UserLocalDataProvider";
import { IUserLocalDTO } from "../../../libs/coreapi-dto/dirs/user";

interface IValid {
    login: string
    hash: string
    idUserGlobal: string
}

const EmployeeCreatorModal: FC<ICreatorModalProps<IEmployeeDTO>> = (props) => {
    const appCtx = useAppContext();
    const userLocalDataProvider = new UserLocalDataProvider(appCtx.coreApiService);
    const [employee, setEmployee] = useState<IEmployeeDTO>(props.data ?? {
        gender: "male"
    } as IEmployeeDTO);
    const [user, setUser] = useState<IEntitySimpleDTO>();

    const { t } = useTranslation();
    const baseT = (value: string) => t('directory.employees.' + value)
    const errorsT = (value: string) => t('errors.' + value);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [option] = useState<IOption[]>(
        [ 
            {displayName: "Мужской", value: "male", }, 
            {displayName: "Женский", value: "female", },
        ] as IOption[] )   

    const [optionValue, setOptionValue] = useState<IOption>(option[0])

    const { isValid, errors, setErrors } = useForm<IValid>({
        validations: {
            login: {
                required: {
                    value: employee.login  ? false : true,
                    message: errorsT("required")
                }
            },
            hash: {
                required: {
                    value: employee.hash  ? false : true,
                    message: errorsT("required")
                }
            },
            idUserGlobal: {
                required: {
                    value: employee.idUserGlobal  ? false : true,
                    message: errorsT("required")
                }
            },
        }
    });

    useEffect(() => {
        userLocalDataProvider.getById(props.data!.idUserGlobal, (data: IUserLocalDTO) => {
            
            setUser({
                displayName: data.fullName,
                idGlobal: data.idGlobal
            }) 
        })
    }, [props.data?.idUserGlobal]);

    const handleSubmit = () => {
        if (isValid()) {
            props.save({ ...employee })
            setIsSubmitting(true)
        }
    }


    return (
        <BaseCreator
            variant={props.variant}
            isSubmitting={isSubmitting}
            save={handleSubmit}
            cancel={props.cancel}
            modalWindowClassName={modalStyles.flexModalWindow}
            valid={!props.lockFromPermission}
        >
            <GridWrapper cols={2}>
                <TextInput
                    labelVariant="required"
                    required
                    label={baseT('login')} value={employee.login}
                    onChange={(value) => setEmployee({ ...employee, login: value })}
                    error={errors.login} onFocus={() => setErrors({ ...errors, login: undefined })} 
                    disabled={props.lockFromPermission}
                />
                <TextInput
                    labelVariant="required"
                    required
                    label={baseT('hash')} value={employee.hash}
                    onChange={(value) => setEmployee({ ...employee, hash: value })}
                    error={errors.hash} onFocus={() => setErrors({ ...errors, hash: undefined })} 
                    disabled={props.lockFromPermission}
                />
            </GridWrapper>
            <GridWrapper cols={2}>
                <GridSelectorInput
                    required
                    id='idUserGlobal'
                    selectedEntity={user}
                    onSelect={e => {
                        setEmployee({ ...employee, idUserGlobal: e?.idGlobal })
                        setUser(e)
                    }}
                    selectorModalJsx={UserLocalSelectorModal}
                    error={errors.idUserGlobal}
                    onFocus={() => setErrors({ ...errors, idUserGlobal: undefined })}
                    label={baseT('idUserGlobal')}
                    value={employee.idUserGlobal}
                    onChange={(value) => setEmployee({ ...employee, idUserGlobal: value })} 
                    disabled={props.lockFromPermission}
                />
                <Select
                    defaultOption={option[0]}
                    label={baseT('gender')} 
                    onSelect={(option) => {
                        setEmployee({ ...employee, gender: option.value })
                        setOptionValue(option)
                    }}
                    value={optionValue}
                    options={[
                        {displayName: "Мужской", value: "male", }, 
                        {displayName: "Женский", value: "female", },
                    ]}>
                </Select>
            </GridWrapper>
            <GridWrapper cols={2}>
                <TextInput
                    label={baseT('personnelNumber')} value={employee.personnelNumber}
                    onChange={(value) => setEmployee({ ...employee, personnelNumber: value })}
                    disabled={props.lockFromPermission}
                />
                {/* <TextInput
                    label={baseT('birthDate')} value={employee.birthDate}
                    onChange={(value) => setEmployee({ ...employee, birthDate: value })}
                    disabled={props.lockFromPermission}
                /> */}
            </GridWrapper>
        </BaseCreator>
    )
}

export default EmployeeCreatorModal